
import { Backdrop, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import React from 'react'
import moment from 'moment';
import { useDispatch } from 'react-redux';



const BulkProcessDatesModal = ({ open, handleClose ,handleFunc=null}) => {
    const [openWarningModal, setOpenWarningModal] = React.useState(false);
    const [date, setDate] = React.useState(moment());
    const [days, setDays] = React.useState(7);
    const onClose = () => {
        handleClose();
        setOpenWarningModal(false);
    }
    const handleStartDateChange = (value) => {
        setDate(value);
    };
    const onProcess=()=>{
        const startDate=moment(date).format('YYYY-MM-DD');
        const endDate=moment(date).add(days-1,'days').format('YYYY-MM-DD');
        if(handleFunc){
            handleFunc(startDate,endDate);
        }
        onClose();
    }
    return (
        <div>
            <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
                <DialogTitle>Bulk Process Dates</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} mt={2} direction={'row'}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                //   sx={{ width: "180px",flex:'none' }}
                                label="Start Date"
                                value={(date)}
                                onChange={(date) => handleStartDateChange(date)}
                                renderInput={(params) => <TextField {...params} />}
                                slotProps={{ textField: { size: "small", fullWidth: true } }}
                            />
                        </LocalizationProvider>
                        <TextField size='small' label='# of days' value={days} onChange={(e) => setDays(e.target.value<1?1:e.target.value>31?31:e.target.value)} sx={{ width: '100px' }} type='number' inputProps={{ max: 31, min: 1 }} />
                    </Stack>

                </DialogContent>
                <DialogActions sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}>
                    <Button variant="contained" onClick={onProcess}>Process</Button>
                    <Button variant="outlined" onClick={onClose}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default BulkProcessDatesModal